import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  Stack,
  TextField,
} from "@mui/material";
import { FiltersBar } from "../style";

const SOURCES = ["TEXT", "VIDEO", "MANUAL", "REFRAMER", "URL_REWRITER"];

export default function FilterBar({
  text,
  users,
  from,
  to,
  userId,
  sources,
  excludeAdmins,
  onFromChange,
  onToChange,
  onUserChange,
  onSourcesChange,
  onExcludeAdminsChange,
  onApply,
  onClear,
}) {
  const selectedUser = users.find((u) => u.id === userId) || null;

  const toggleSource = (src) => {
    if (sources.includes(src)) {
      onSourcesChange(sources.filter((s) => s !== src));
    } else {
      onSourcesChange([...sources, src]);
    }
  };

  return (
    <FiltersBar>
      <TextField
        size="small"
        type="date"
        label={text.filters.from}
        value={from}
        onChange={(e) => onFromChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ minWidth: 160 }}
      />
      <TextField
        size="small"
        type="date"
        label={text.filters.to}
        value={to}
        onChange={(e) => onToChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ minWidth: 160 }}
      />
      <Autocomplete
        size="small"
        options={users}
        value={selectedUser}
        onChange={(_, v) => onUserChange(v?.id || "")}
        getOptionLabel={(o) => o?.name || o?.email || ""}
        isOptionEqualToValue={(a, b) => a?.id === b?.id}
        renderInput={(params) => (
          <TextField
            {...params}
            label={text.filters.user}
            placeholder={text.filters.allUsers}
          />
        )}
        sx={{ minWidth: 220 }}
      />
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Box sx={{ fontSize: 12, color: "text.secondary" }}>
          {text.filters.source}
        </Box>
        <Stack direction="row" spacing={0.5} flexWrap="wrap">
          {SOURCES.map((src) => {
            const active = sources.includes(src);
            return (
              <Chip
                key={src}
                label={text.sources[src] || src}
                size="small"
                color={active ? "primary" : "default"}
                variant={active ? "filled" : "outlined"}
                onClick={() => toggleSource(src)}
                sx={{ mb: 0.5 }}
              />
            );
          })}
        </Stack>
      </Box>
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            checked={!!excludeAdmins}
            onChange={(e) => onExcludeAdminsChange?.(e.target.checked)}
          />
        }
        label={text.filters.excludeAdmins}
        sx={{ ml: 0.5, mr: 0 }}
      />
      <Box sx={{ flex: 1 }} />
      <Stack direction="row" spacing={1}>
        <Button variant="outlined" size="small" onClick={onClear}>
          {text.filters.clear}
        </Button>
        <Button variant="contained" size="small" onClick={onApply}>
          {text.filters.apply}
        </Button>
      </Stack>
    </FiltersBar>
  );
}
